import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './FilterDropdownSet.scss'

const FilterDropdownsSet = props => {
  let filterDropdowns = []
  let dropdownIdx = 0
  for (let label in props.filterOptions) {
    const optionInfo = props.filterOptions[label]
    filterDropdowns.push(
      <React.Fragment key={dropdownIdx}>
        {optionInfo.renderDropdownContent()}
      </React.Fragment>
    )
    dropdownIdx++
  }

  const dropdownClass = classNames('FilterDropdownSet', {
    'FilterDropdownSet--open': !!props.activeDropdown
  })

  return <div className={dropdownClass}>{filterDropdowns}</div>
}

FilterDropdownsSet.propTypes = {
  activeDropdown: PropTypes.string,
  filterOptions: PropTypes.object
}

export default FilterDropdownsSet
